var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.inScud)?_c('b-dropdown-item',{on:{"click":function($event){return _vm.$emit('send-to-scud')}}},[_c('img',{staticClass:"icon-pdf",attrs:{"src":_vm.iconPath('v_scud.svg'),"alt":""}}),_vm._v(" Передать в СКУД ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }